// component vs. container https://medium.com/@dan_abramov/smart-and-dumb-components-7ca2f9a7c7d0
import { connect } from 'react-redux';
import { actions as previewActions } from '~/story-preview';
import { formatPostLists } from '~/queue/util';
// load the presentational component
import { actions as storyGroupComposerActions } from '~/story-group-composer';
import { actions } from './reducer';
import PastRemindersWrapper from './components/PastRemindersWrapper';
import { header, subHeader } from './components/PastRemindersPosts/postData';

export default connect(
  (state, ownProps) => {
    const { profileId } = ownProps;
    const currentProfile = state.pastReminders.byProfileId[profileId];
    const profileData = state.profileSidebar.profiles.find(
      (p) => p.id === ownProps.profileId
    );

    if (currentProfile && profileData) {
      return {
        header,
        subHeader,
        viewType: state.pastReminders.viewType,
        loading: currentProfile.loading,
        loadingMore: currentProfile.loadingMore,
        moreToLoad: currentProfile.moreToLoad,
        page: currentProfile.page,
        items: formatPostLists({
          isManager: profileData.isManager,
          weekStartsOnMonday: state.user.week_starts_monday,
          profileService: profileData.service,
          profileTimezone: profileData.timezone,
          scheduleSlotsEnabled: false,
          posts: currentProfile.posts,
          orderBy: 'due_at',
          sortOrder: 'desc',
        }),
        total: currentProfile.total,
        showComposer: state.pastReminders.showComposer,
        showStoriesComposer: state.pastReminders.showStoriesComposer,
        editMode: state.pastReminders.editMode,
        isManager: state.profileSidebar.selectedProfile.isManager,
        isDisconnectedProfile:
          state.profileSidebar.selectedProfile.isDisconnected,
        userData: state.user,
        showStoryPreview: state.pastReminders.showStoryPreview,
      };
    }
    return {};
  },
  (dispatch, ownProps) => ({
    onShareAgainClick: ({ post }, viewType) => {
      if (viewType && viewType === 'stories') {
        dispatch(
          actions.handleShareStoryGroupAgain({
            post,
            profileId: ownProps.profileId,
          })
        );
      } else {
        dispatch(
          actions.handleShareAgainClick({
            post,
            profileId: ownProps.profileId,
          })
        );
      }
    },
    onConfirmDismissComposer: () => {
      dispatch(storyGroupComposerActions.resetStoryGroupState());
      dispatch(actions.handleComposerCreateSuccess());
      dispatch(actions.handleCloseStoriesComposer());
    },
    onComposerCreateSuccess: () => {
      dispatch(actions.handleComposerCreateSuccess());
    },
    handleCloseStoriesComposer: () => {
      dispatch(actions.handleCloseStoriesComposer());
    },
    onMobileClick: ({ post }, viewType) => {
      if (viewType && viewType === 'stories') {
        dispatch(
          actions.handleStoryGroupMobileClick({
            post,
            profileId: ownProps.profileId,
          })
        );
      } else {
        dispatch(
          actions.handleMobileClick({
            post,
          })
        );
      }
    },
    onToggleViewType: (viewType) => {
      dispatch(
        actions.handleToggleViewType({
          profileId: ownProps.profileId,
          viewType,
        })
      );
    },
    onPreviewClick: ({ stories, profileId, id, scheduledAt, serviceId }) => {
      dispatch(
        previewActions.handlePreviewClick({
          stories,
          profileId,
          id,
          scheduledAt,
        })
      );
      dispatch(actions.handlePreviewClick());
    },
    onClosePreviewClick: () => {
      dispatch(actions.handleClosePreviewClick());
    },
  })
)(PastRemindersWrapper);

// export reducer, actions and action types
export { default as reducer, actions, actionTypes } from './reducer';
export { default as middleware } from './middleware';
